import { ColDef } from '@ag-grid-community/core';

import { MultiLineValueTypes } from './cell-renderers/multi-line-value-types';

export enum ColumnType {
	DIMENSION_COLUMN = 'dimension-column',
	ORDER_NUMBER_COLUMN = 'order-number-column',
	NUMBER_COLUMN = 'number-column',
	DATE_COLUMN = 'date-column',
	TEXT_COLUMN = 'text-column',
	TRANSLATED_COLUMN = 'translated-column',
	COLOUR_COLUMN = 'color-column'
}

export interface ColDefWithFields<TData = unknown, TValue = unknown> extends ColDef<TData, TValue> {
	fields?: string[];
	columnType?: ColumnType;
	valueType?: MultiLineValueTypes;
	isMandatoryOnLeft?: boolean;
	groupId?: string;
	/**
	 * This is used if filter should be applied on multiple values for a single field
	 * Eg: If from order type, schedule business order is selected, then filter will be appplied
	 * suppierOrderType : 'E' or suuplierOrderType : 'F'
	 */
	multiFilterCodes?: Map<string, string[]>;
	applyLikeCondition?: boolean;
}
